import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { StyleSheet, Text, View } from 'react-native';
import { Checkbox } from 'react-native-paper';

export type CheckboxInputFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
};

const CheckboxInputField = <T extends FieldValues>({ name, control, label }: CheckboxInputFieldProps<T>) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <>
        <View style={styles.mainContainer}>
          <Checkbox.Android
            color="black"
            status={!!field.value ? 'checked' : 'unchecked'}
            onPress={() => field.onChange(!field.value)}
          />
          <Text style={styles.labelText}>{label}</Text>
        </View>
        {error?.message !== undefined ? <Text style={styles.errorText}>{error?.message}</Text> : <></>}
      </>
    )}
  />
);

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center'
  },

  labelText: {
    fontSize: 14,
    fontWeight: '400',
    flex: 1
  },

  errorText: {
    marginTop: 5,
    fontSize: 12,
    color: 'red'
  }
});

export default CheckboxInputField;
